import axios from "axios";
import store from "../../Redux/store";
import { Logout, RefreshToken } from "../Auth/Auth";
import { setAuthToken } from "../../Redux/AuthSlice/authSlice";

const API_PATH = process.env.REACT_APP_API_URL;
// const API_PATH = "http://127.0.0.1:8080/";
// const API_PATH = "http://192.168.0.167:8080/";
// const API_PATH = "http://192.168.0.196:8080/";

const sendDeleteCallToSever = (API_URL) => {
  return axios.delete(API_URL);
};

const sendPatchCallToSever = (params, API_URL) => {
  return axios.patch(API_URL, params);
};

const sendPostCallToSever = (params, API_URL, oposite = false) => {
  if (oposite) return axios.patch(API_URL, params);
  else return axios.post(API_URL, params);
};

const sendGetCallToSever = (API_URL) => {
  return axios.get(API_URL);
};

axios.interceptors.request.use(
  function (config) {
    let apiPath = API_PATH;
    let url = config.url;

    let auth = store.getState().authSlice.auth_token;
    // CREATE HEADER OBJECT
    let headers = {
      "content-type": "application/json",
      Authorization: "Bearer " + auth,
    };
    config.headers = headers;

    if (!config.retry) config.url = apiPath + url;
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    if (response) {
      let parsedData = response.data;
      if (response.status === 200 || response.status === 201) {
        return { data: parsedData, error: "" };
      } else {
        return { data: {}, error: response.error.msg };
      }
    }
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401) {
      try {
        // Attempt to refresh the token
        let dispatch = store.dispatch;
        const refreshToken = await RefreshToken();
        dispatch(setAuthToken(refreshToken));
        if (refreshToken) {
          // Token refresh successful, update the original request with the new token
          // originalRequest.headers.Authorization = `Bearer ${refreshToken}`;
          originalRequest.retry = true;

          return new Promise((resolve) => {
            resolve(axios(originalRequest));
          });
        } else {
          // Token refresh failed, redirect to logout
          Logout();
        }
      } catch (refreshError) {
        // An error occurred while refreshing the token, redirect to logout
        console.error("Token refresh error:", refreshError);
        Logout();
      }
    } else if (error.message && error.message === "Network Error") {
      console.log("network error: ", error);
    } else {
      return { data: {} };
    }
    return Promise.reject(error);
  }
);

export {
  sendPostCallToSever,
  sendGetCallToSever,
  sendDeleteCallToSever,
  sendPatchCallToSever,
};
